import React, {useState, useEffect} from "react";

import ContactUsContent from "../content/ContactUsContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

import { Helmet } from "react-helmet-async";
import LoadingBar from 'react-top-loading-bar';

function ContactUs() {
    const [progress, setProgress] = useState(0);
        
    useEffect(()=>{
        setProgress(100);
    },[])
    return(
        <>
        <Helmet>
            <title>Contact Us | Suvivah - Get in Touch</title>

            <meta
                name="description"
                content="Contact Suvivah for assistance with your matrimonial profile, account, or general inquiries. We're here to help you on your journey toward an ideal marriage."
            />

            <meta
                name="keywords"
                content="Contact Suvivah, Matrimonial Support, Marriage Assistance, Help, Contact Us, Bengali Matrimony"
            />

            <meta name="robots" content="index, follow" />
            <meta name="author" content="Suvivah" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#dc3545" />

            <link rel="canonical" href="https://suvivah.org/contact-us" />

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Suvivah" />
            <meta property="og:locale" content="en_IN" />
            <meta property="og:title" content="Contact Us | Suvivah" />
            <meta
                property="og:description"
                content="Have questions? Contact Suvivah for support and assistance."
            />
            <meta property="og:url" content="https://suvivah.org/contact-us" />
            <meta
                property="og:image"
                content="https://suvivah.org/images/logo.png"
            />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Contact Us | Suvivah" />
            <meta
                name="twitter:description"
                content="Contact Suvivah for support and assistance."
            />
            <meta
                name="twitter:image"
                content="https://suvivah.org/images/logo.png"
            />
        </Helmet>

        <Navbar />
        <ContactUsContent/>
        <LoadingBar
            color='#a11800'
            height={4}
            background='#fff4a1'
            loaderSpeed={2000}
            waitingTime={2000}
            shadow={true}
            progress={progress}
            onLoaderFinished={() => setProgress(0)}
        />
        <Footer />        
        </>
    );
}

export default ContactUs;